/**
 * Motion and animation tokens inspired by Apple's design principles
 * Provides consistent timing, easing, and spring configurations
 */

export const motionTokens = {
  // Apple-inspired easing curves
  easing: {
    standard: [0.4, 0.0, 0.2, 1] as const,
    decelerate: [0.0, 0.0, 0.2, 1] as const,
    accelerate: [0.4, 0.0, 1, 1] as const,
    sharp: [0.4, 0.0, 0.6, 1] as const,
    // Apple's signature ease-out
    appleEaseOut: [0.25, 0.46, 0.45, 0.94] as const,
  },

  // Duration tokens in milliseconds
  duration: {
    instant: 0,
    fast: 150,
    normal: 250,
    slow: 350,
    slower: 500,
  },

  // Spring configurations for React Native Reanimated
  spring: {
    gentle: {
      damping: 20,
      stiffness: 300,
      mass: 1,
    },
    bouncy: {
      damping: 15,
      stiffness: 400,
      mass: 1,
    },
    snappy: {
      damping: 25,
      stiffness: 500,
      mass: 1,
    },
  },
} as const;

// Type definitions for motion tokens
export type EasingCurve = keyof typeof motionTokens.easing;
export type Duration = keyof typeof motionTokens.duration;
export type SpringConfig = keyof typeof motionTokens.spring;

// Animation configuration interface
export interface AnimationConfig {
  duration?: Duration;
  easing?: EasingCurve;
  delay?: number;
}

export interface SpringAnimationConfig {
  spring: SpringConfig;
  delay?: number;
}
